<section class="card-section">
  <div class="card-section__header">
    <div class="card-section__title">
      <h2 class="card-section__heading">{{ heading }}</h2>
      @if (badge) {
        <span class="card-section__badge">{{ badge }}</span>
      }
    </div>
    <div class="card-section__actions">
      <ng-content select="[sectionActions]"></ng-content>
    </div>
  </div>
  <div class="card-section__body">
    <ng-content></ng-content>
  </div>
</section>
